import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './index.scss';
import { Modal } from 'react-bootstrap';
import backicon from '../../../../../Assets/icons/backIcon.svg';
import downloadIcon from '../../../../../Assets/icons/download.svg';
import plusIcon from '../../../../../Assets/icons/plus-circle.svg';
import MinusIcon from '../../../../../Assets/icons/Minus-circle.svg'
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import axiosInstance from '../../../../services/api/API';
import moment  from "moment";

//plus-circle.svg Minus-circle.svg

const SuperVisorPartDetails = () => {
    const location = useLocation();
    const { data } = location?.state || {};
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const token = localStorage.getItem("authToken");
    const id = queryParams.get('id');
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [selectedAssignee, setSelectedAssignee] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [showRemarkModal, setShowRemarkModal] = useState(false); // Add state for remark modal
    const [remark, setRemark] = useState('');
    const [jobCardDetails, setJobCardDetails] = useState();
    const [jobCardIssueList, setJobCardIssueList] = useState([])// Add state for remark
    const [assigneeList] = useState([
        { name: 'Telecaller 1', assignedLeads: 5 },
        { name: 'Telecaller 2', assignedLeads: 10 },
        { name: 'Telecaller 3', assignedLeads: 3 },
        { name: 'Sales Manager 1', assignedLeads: 8 },
        { name: 'Sales Manager 2', assignedLeads: 6 },
        { name: 'Sales Manager 3', assignedLeads: 2 },
    ]);
    const [issueId, setIssueId] = useState(0);
    const businessPartnerId = localStorage.getItem("business_partner_id")
  console.log(businessPartnerId, "businesspartnerid")

    const IssueList = [{
        id: 1,
        complainNo: 'VD001',
        Technicianname: 'Sudhir Kadam',
        complenDiscription: 'Breek Shoo Issue',
        Repair: 'Break Shoe',
        WorkShop: 'Andheri Work Shop',
        EstimateCost: '5000',
        EstimateTime: '5Hrs',
        IssueStatus: 'Inprogress',
        Remark: 'Find Break Shoe',
        part: 'Brack Drun',
        PartType: 'Spare part',
        Issue: 'Abnormal Noise',
        itemName: 'Brack Drun',
        GoodsQty: '1',
        RepairStatus: 'Done'
    },
    {
        id: 2,
        complainNo: 'VD001',
        Technicianname: 'Sudhir Kadam',
        complenDiscription: 'Breek Shoo Issue',
        Repair: 'Break Shoe',
        WorkShop: 'Andheri Work Shop',
        EstimateCost: '5000',
        EstimateTime: '5Hrs',
        IssueStatus: 'Inprogress',
        Remark: 'Find Break Shoe',
        part: 'Brack Drun',
        PartType: 'Spare part',
        Issue: 'Abnormal Noise',
        itemName: 'Brack Drun',
        GoodsQty: '1',
        RepairStatus: 'Done'

    },
    {
        id: 3,
        complainNo: 'VD001',
        Technicianname: 'Sudhir Kadam',
        complenDiscription: 'Breek Shoo Issue',
        Repair: 'Break Shoe',
        WorkShop: 'Andheri Work Shop',
        EstimateCost: '5000',
        EstimateTime: '5Hrs',
        IssueStatus: 'Inprogress',
        Remark: 'Find Break Shoe',
        part: 'Brack Drun',
        PartType: 'Spare part',
        Issue: 'Abnormal Noise',
        itemName: 'Brack Drun',
        GoodsQty: '1',
        RepairStatus: 'Done'


    }
    ]

    const [filteredAssigneeList, setFilteredAssigneeList] = useState(assigneeList);


    const handleSearchChange = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        const filteredList = assigneeList.filter(assignee =>
            assignee.name.toLowerCase().includes(value)
        );
        setFilteredAssigneeList(filteredList);
    };

    const StatusUpdate = async (data, type) => {
        console.log('data', data);
        try {
            const response = await axiosInstance.post('/supervisorpartapproval/supervisorpartapprovalitemupdate',
                {
                    part_detail_id: data?.part_detail_id || '',
                    business_partner_id: data?.business_partner_id || null,
                    job_card_id: data?.job_card_id || null,
                    is_super_viser_approve: type


                }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response?.status) {
                fetchJobCardIssueList();
                fetchJobCardDetails();
            }
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }

    }

    //     const handleAssign = () => {
    //         console.log(`Assigning ${modalType} to ${selectedAssignee}`);
    //         // Implement your assignment logic here
    //         setShowModal(false);
    //     };

    //   setShowRemarkModal(false);
    //     };


    const assigneeTypeFilter = modalType === 'Telecaller' ? 'Telecaller' : 'Sales Manager';
    const filteredAssignees = assigneeList.filter(assignee => assignee.name.includes(assigneeTypeFilter));


    const fetchJobCardIssueList = async (page = 0, pageSize = 1) => {
        try {
            const response = await axiosInstance.post('/jobcard/jobcardview', {
                business_partner_id: data?.business_partner_id?data?.business_partner_id : 1,
                job_card_id: data?.job_card_id,
                login_user_id: null,

            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });

            const formattedData = response.data.data.map((item, index) => ({
                ...item,
                //"Sr_No": index + 1,
                //:item?.solved === 0 ? 'Pending': 'Done',
                // job_card_no:onClickNavigetion(item)

            }));

            setJobCardDetails(formattedData[0])
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };

    const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
        try {
            const response = await axiosInstance.post('/jobcard/getservicesdetails', {
                business_partner_id: data?.business_partner_id || businessPartnerId,
                job_card_id: data?.job_card_id,
                login_user_id: null,
                Type: "SuperviserPartApprovalView"

            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });

            const formattedData = response.data.data.map((item, index) => ({
                ...item,
                //"Sr_No": index + 1,
                //:item?.solved === 0 ? 'Pending': 'Done',
                // job_card_no:onClickNavigetion(item)

            }))
            setJobCardIssueList(formattedData)
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };

    useEffect(() => {
        if (data) {
            fetchJobCardIssueList();
            fetchJobCardDetails();
        }
    }, []);

    const backNavigate=()=>{
      navigate("/manage-services/supervisor-part-approval")
    }

    return (
        <div className="container-fuiled">
      <div className="OnboardManagamentContainer  mt-2 ">
        <span className="backbtntitle">
        <img src={backicon} alt="back" style={{ marginRight: 5 }} onClick={()=>backNavigate()}/>{" "}
         Supervisor Part Details
        </span>
      </div>
      <div className="container-fuiled row  ">
      <div className="col-5 vechalDetails">
          <h5 className='m-3 '>Vehicle Details</h5>
          <div className='m-3'>
            <div className="vechal-Details-SubView ">
              <div className="details-item">
                <span className="details-label">Job Card No.</span>
                <span className="details-value">
                  {jobCardDetails?.job_card_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Job Card Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.transaction_date).format(
                    "MM/DD/YYYY"
                  )}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Customer Name</span>
                <span className="details-value">
                  {jobCardDetails?.customer_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Mobile No.</span>
                <span className="details-value">
                  {jobCardDetails?.contact_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Reg. No.</span>
                <span className="details-value">
                  {jobCardDetails?.registration_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Chassis No.</span>
                <span className="details-value">
                  {jobCardDetails?.chassis_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Engine No.</span>
                <span className="details-value">
                  {jobCardDetails?.engineno || "-"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">Pin Code</span>
                <span className="details-value">
                  {jobCardDetails?.pincode || "-"}
                </span>
              </div> */}

              <div className="details-item">
                <span className="details-label">Product Name</span>
                <span className="details-value">
                  {jobCardDetails?.product_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Sub Product Name</span>
                <span className="details-value">
                  {jobCardDetails?.subproduct_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Make</span>
                <span className="details-value">
                  {jobCardDetails?.make_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Model</span>
                <span className="details-value">
                  {jobCardDetails?.model_name || "-"}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Variant</span>
                <span className="details-value">
                  {jobCardDetails?.variant_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Variant Color</span>
                <span className="details-value">
                  {jobCardDetails?.color_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Fuel Type</span>
                <span className="details-value">
                  {jobCardDetails?.fuel_type_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty Start Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_startdate ).format('DD/MM/YYYY')|| "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty End Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_enddate).format('DD/MM/YYYY') || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty Period</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_period).format('DD/MM/YYYY') || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Supervisor</span>
                <span className="details-value">
                  {jobCardDetails?.supervisor_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Allocation Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.allocation_date).format(
                    "DD/MM/YYYY"
                  ) || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Job Estimate Amt.</span>
                <span className="details-value">
                  {jobCardDetails?.job_estimate_amount || 0}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Job Status</span>
                <span className="details-value">
                  {jobCardDetails?.status == 0 ? "Pending" : "Done"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">Complain</span>
                <span className="details-value">
                  {jobCardDetails?.complaint}
                </span>
              </div> */}
              <div className="details-item">
                <span className="details-label">Signature</span>
                <div style={{ display: "flex", gap: 5 }}>
                  <img
                    src={jobCardDetails?.signature_path}
                    style={{ height: 30, width: 50 }}
                  />
                  <span className="details-value">Verify</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-7">
          
            <h5 className='m-3'>Part Details</h5>
          {jobCardIssueList?.map((issueDetails) => (
                <div className='issue-list-container'>
                    <div className="details-section">
                        <div className="details-approve-grid ">
                            <div className="details-item">
                                <span className="details-label">Item Name</span>
                                <span className="details-value">{issueDetails?.item_name}</span>
                            </div>
                            <div className="details-item">
                                <span className="details-label">Item Type</span>
                                <span className="details-value">{issueDetails?.itemtype}</span>
                            </div>
                            <div className="details-item">
                                <span className="details-label">Status</span>
                                <span className="details-value">{issueDetails?.is_super_viser_approve == "Y" ? "Approved" : "Rejected"}</span>
                            </div>
                            <div className="details-item">
                                <>
                                    {issueDetails?.is_super_viser_approve == "Y" ?
                                        // <div className='downloadiconwrapper center' onClick={() => StatusUpdate(issueDetails, "N")}>
                                        //     <h6 className='downloadTitle'>Rejected</h6>

                                        // </div>
                                            <button

                                            onClick={() => StatusUpdate(issueDetails, "Y")
                                            }
                                            // title='Approve'
                                            className="submit-btn"
                                        >
                                           Rejected
                                        </button>
                                        :
                                        <button

                                            onClick={() => StatusUpdate(issueDetails, "Y")
                                            }
                                            // title='Approve'
                                            className="submit-btn"
                                        >
                                            Approve
                                        </button>
                                        // <div className='downloadiconwrapper center' onClick={()=>StatusUpdate(issueDetails,"Y")}>
                                        //     <h6 className='downloadTitle'>Approve</h6>

                                        // </div>
                                    }
                                </>                     </div>

                        </div>
                    </div>
                </div>
            ))}
          </div>
        </div>
      </div> 
    );
};

export default SuperVisorPartDetails;
